import React, { useState, useEffect } from "react";
import { Col, Nav, Tab } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import CameraHeightView from "../CameraSliderView/CameraHeightView";
import CameraWidthDepthView from "../CameraSliderView/CameraWidthDepthView";
import "../CameraSetting.css";
import "../CameraSliderView/CameraHeightView.module.css";
import { camPositionToCamNumber } from "../constants";
import SimpleDropdownFilter from "../../../../../components/SimpleDropdownFilter.component";
const CameraSetting = (props) => {
  const {
    cameraPosition,
    s3CameraForm,
    setS3CameraForm,
    getCameraRawObject,
    inputValue,
    setInputValue,
    steps,
    unitType,
    isFeet,
    switchStatus,
    s3SettingsUntouchedObject,
    selectedCamera,
  } = props;

  const { t } = useTranslation();

  const [tabKey, setTabKey] = useState(1);
  const [forkliftClass, setForkliftClass] = useState("rear");
  const [obstacleTypeList, setObstacleTypeList] = useState([]);
  const [isHeight, setIsHeight] = useState(false);
  const [isDepth, setIsDepth] = useState(false);
  const [obstacle, setObstacle] = useState("pedestrian");
  const [value, setValue] = useState({
    pedestrian: { pos1: 0, pos2: 0, pos3: 0, pos4: 0, pos5: 0 },
    object: { pos1: 0, pos2: 0, pos3: 0, pos4: 0, pos5: 0 },
  });

  const styles = {
    textStyle: {
      fontFamily: "Open Sans",
      fontSize: "0.7rem",
      color: "#707070",
      textAlign: "left",
    },
  };
  const getSwitchStatus = () => {
    return switchStatus[selectedCamera];
  };

  useEffect(() => {
    const currentSwitchStatus = getSwitchStatus();

    let currentObstacleType = [];
    if (currentSwitchStatus?.pedestrian?.inMotion || currentSwitchStatus?.pedestrian?.inStationary) {
      currentObstacleType.push({ value: "pedestrian", label: "Pedestrian" });
    }
    if (currentSwitchStatus?.object?.inMotion || currentSwitchStatus?.object?.inStationary) {
      currentObstacleType.push({ value: "object", label: "Object" });
    }
    setObstacleTypeList([...currentObstacleType]);
    setObstacle(
      currentSwitchStatus?.pedestrian?.inMotion || currentSwitchStatus?.pedestrian?.inStationary
        ? "pedestrian"
        : "object"
    );
  }, [switchStatus]);

  useEffect(() => {
    setForkliftClass(cameraPosition?.[1]);
  }, [steps, cameraPosition]);

  useEffect(() => {
    setForkliftClass(selectedCamera);
  }, [selectedCamera]);

  useEffect(() => {
    if (tabKey === 1) {
      setIsHeight(false);
      setIsDepth(false);
    } else if (tabKey === 2) {
      setIsHeight(false);
      setIsDepth(true);
    } else {
      setIsHeight(true);
      setIsDepth(false);
    }
  }, [tabKey]);

  useEffect(() => {
    const camIndex = camPositionToCamNumber[selectedCamera] - 1;
    if (!s3CameraForm[camIndex]) {
      return;
    }
    let settingPedestrian = s3CameraForm[camIndex]["pedestrian"];
    let settingObject = s3CameraForm[camIndex]["object"];

    let settingSczPedestrian = s3CameraForm[camIndex]["sczPedestrian"];
    let settingSczObject = s3CameraForm[camIndex]["sczObject"];

    let newInputValue = {};

    newInputValue.pedestrian = {
      pos1: settingPedestrian.depth,
      pos2: settingPedestrian.left,
      pos3: settingPedestrian.right,
      pos4: settingPedestrian.top,
      pos5: settingPedestrian.bottom,
      pos6: settingPedestrian.middle,
    };
    newInputValue.object = {
      pos1: settingObject.depth,
      pos2: settingObject.left,
      pos3: settingObject.right,
      pos4: settingObject.top,
      pos5: settingObject.bottom,
      pos6: settingObject.middle,
    };

    newInputValue.sczPedestrian = {
      /*  pos1: settingPedestrian.depth, */
      pos2: settingSczPedestrian.left,
      pos3: settingSczPedestrian.right,
      pos4: settingSczPedestrian.top,
      pos5: settingSczPedestrian.bottom,
      pos6: settingSczPedestrian.middle,
      zones: settingSczPedestrian?.zones,
    };

    newInputValue.sczObject = {
      /*  pos1: settingObject.depth, */
      pos2: settingSczObject.left,
      pos3: settingSczObject.right,
      pos4: settingSczObject.top,
      pos5: settingSczObject.bottom,
      pos6: settingSczObject.middle,
      zones: settingSczObject?.zones,
    };

    setInputValue({ ...inputValue, ...newInputValue });
  }, [cameraPosition, selectedCamera, s3SettingsUntouchedObject]);

  useEffect(() => {
    let newS3CameraForm = { ...s3CameraForm };
    newS3CameraForm[camPositionToCamNumber[selectedCamera] - 1] = getCameraRawObject(
      { number: newS3CameraForm[camPositionToCamNumber[selectedCamera] - 1]?.sensor, name: forkliftClass },
      inputValue
    );
    setS3CameraForm({ ...newS3CameraForm });
  }, [inputValue]);

  const updateNearMissDetection = (updatedObject) => {
    s3CameraForm[camPositionToCamNumber[selectedCamera] - 1][obstacle] = {
      depth: updatedObject[obstacle].pos1,
      left: updatedObject[obstacle].pos2,
      right: updatedObject[obstacle].pos3,
      top: updatedObject[obstacle].pos4,
      bottom: updatedObject[obstacle].pos5,
      middle: updatedObject[obstacle].pos6,
    };
    setS3CameraForm({ ...s3CameraForm });

    setInputValue(updatedObject);
  };

  return s3CameraForm && Object.keys(s3CameraForm)?.length > 0 ? (
    obstacleTypeList.length !== 0 ? (
      <div className="camera-setting-container">
        <div className="d-flex justify-content-center">
          {isHeight ? (
            <CameraHeightView
              setTabKey={setTabKey}
              getCameraRawObject={getCameraRawObject}
              obstacle={obstacle}
              value={value}
              setValue={setValue}
              inputValue={inputValue}
              setInputValue={updateNearMissDetection}
              s3CameraForm={s3CameraForm}
              setS3CameraForm={setS3CameraForm}
              forkliftClass={forkliftClass}
              setForkliftClass={setForkliftClass}
              selectedCamera={selectedCamera}
              unitType={unitType}
              isFeet={isFeet}
              s3SettingsUntouchedObject={s3SettingsUntouchedObject}
            />
          ) : (
            <CameraWidthDepthView
              setTabKey={setTabKey}
              getCameraRawObject={getCameraRawObject}
              obstacle={obstacle}
              value={value}
              setValue={setValue}
              inputValue={inputValue}
              setInputValue={updateNearMissDetection}
              s3CameraForm={s3CameraForm[0]}
              setS3CameraForm={setS3CameraForm}
              isDepth={isDepth}
              isHeight={isHeight}
              forkliftClass={forkliftClass}
              setForkliftClass={setForkliftClass}
              selectedCamera={selectedCamera}
              unitType={unitType}
              isFeet={isFeet}
              s3SettingsUntouchedObject={s3SettingsUntouchedObject}
            />
          )}
        </div>
        <div className="">
          <div className="">
            <div className="camera-setting-dropdown mt-1">
              <Col lg={4} className="pl-0">
                <div className="obstacle-select mb-1">
                  <SimpleDropdownFilter
                    value={obstacle}
                    filter={{
                      type: "cam-position",
                    }}
                    options={obstacleTypeList}
                    label={t("Obstacle")}
                    handleFilter={(obj) => setObstacle(obj.value)}
                  />
                </div>
                <Tab.Container id="left-tabs-example" activeKey={tabKey} defaultActiveKey="1">
                  <Nav
                    variant="pills"
                    className="flex-row m-0 tab-setting"
                    style={{ backgroundColor: "#F2F2F2", width: "100%" }}
                  >
                    <Nav.Item
                      style={{ flex: "1" }}
                      onClick={() => {
                        setTabKey(1);
                        setIsHeight(false);
                        setIsDepth(false);
                      }}
                    >
                      <Nav.Link eventKey="1" className="p-2 pr-3 pl-3">
                        <Trans>WIDTH</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item
                      style={{ flex: "1" }}
                      onClick={() => {
                        setTabKey(2);
                        setIsHeight(false);
                        setIsDepth(true);
                      }}
                    >
                      <Nav.Link eventKey="2" className="p-2 pr-3 pl-3">
                        <Trans>DEPTH</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item
                      style={{ flex: "1" }}
                      onClick={() => {
                        setTabKey(3);
                        setIsHeight(true);
                      }}
                    >
                      <Nav.Link eventKey="3" className="p-2 pr-3 pl-3">
                        <Trans>HEIGHT</Trans>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <div style={styles.textStyle}>
                    {(tabKey === 1 || tabKey === 2 || tabKey === 3) && (
                      <span>
                        <Trans>Define the dimensions for the detection area</Trans>
                      </span>
                    )}
                  </div>
                </Tab.Container>
              </Col>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <p className="default-text text-open-sans">
        <Trans>
          Please turn on detection by obstacle type, in camera preferences, to define near-miss detection
          values.
        </Trans>
      </p>
    )
  ) : (
    <p>Loading.......</p>
  );
};

export default CameraSetting;
